import React from 'react';

const brands = [
  { img: '/images/chanel.png' },
  { img: '/images/puma.png' },
  { img: '/images/zara.png' },
  { img: '/images/nike.png' },
  { img: '/images/dior.png' },
  { img: '/images/hm.png' }
];

function Brands() {
  return (
    <div className="w-full flex flex-row justify-center items-center content-center text-center bg-part mt-10 brandscontainer">
      {brands.map((brand, index) => (
        <div key={index} className="m-5 flex flex-row justify-center items-center content-center">
          <img src={brand.img} alt={`Brand ${index + 1}`} />
        </div>
      ))}
    </div>
  );
}

export default Brands;
